<script>
import ChooseFiles from './ChooseFiles';
import { plicAxios, plicV1Axios } from '../utils/axios';
import Vue from 'vue';
import { logError } from '../utils/bugsnag';

export default {
	props: {
		project: null
	},
	data: () => ({
		checkedTemplateFields: true
	}),
	mixins: [ChooseFiles],
	methods: {
		onLoadUploadRequirements() {
			this.loading = true;
			this.checkedTemplateFields = true;
			if(!this.project.plicSubjectAlbumId) {
				plicAxios.get('albums?parent_resource_type=project&parent_resource_id=' + this.project.plicProjectId + '&tag=Subject+Photos').then((response) => {
					let albums = response.data.albums;
					if(albums.length) {
						Vue.set(this.project, 'plicSubjectAlbumId', albums[0].id);
						this.checkDoneLoading();
					} else {
						plicAxios.post('albums', {
							album: {
								name: 'Subject Photos',
								tags: [
									'Subject Photos'
								]
							},
							parent_resource_type: 'project',
							parent_resource_id: this.project.plicProjectId
						}).then((response) => {
							Vue.set(this.project, 'plicSubjectAlbumId', response.data.album.id);
							this.checkDoneLoading();
						}).catch((error) => {
							this.error('Failed to load subject album', error);
						});
					}
				}).catch((error) => {
					this.error('Failed to load subject album', error);
				});
			}

			if(!this.project.subjects && window.$?.loadSubjects) {
				// TODO: Add tests
				window.$.loadSubjects({
					plicProjectId: $.activeProjectRow.plicProjectId,
					populateWithTemplate: true,
					onComplete: (subjects, projectTemplate) => {
						Vue.set(this.project, 'subjects', subjects);
						Vue.set(this.project, 'template', projectTemplate);
						Vue.set(this.project, 'templateFields', projectTemplate.subject_fields);
						Vue.set(this.project, 'plicTemplateId', projectTemplate.id);

						this.checkedTemplateFields = false;
						this.checkForTemplateFields();

						this.checkDoneLoading();
					}
				});
			} else if(!this.project.templateFields) {
				plicAxios.get('projects/' + this.project.plicProjectId + '?include_project_template=true').then((response) => {
					if(!response.data.project_template) {
						logError(null, 'Failed to load project template from API', {
							response: response.data
						});
					}
					Vue.set(this.project, 'template', response.data.project_template);
					Vue.set(this.project, 'templateFields', response.data.project_template.subject_fields);
					Vue.set(this.project, 'plicTemplateId', response.data.project_template.id);

					this.checkedTemplateFields = false;
					this.checkForTemplateFields();

					this.checkDoneLoading();
				}).catch((error) => {
					this.error('Failed to load project', error);
				});
			}

			this.checkDoneLoading();
		},
		async checkForTemplateFields() {
			if(this.project.projectType && window.$.projectTypeFieldSets && window.$.projectTypeFieldSets[this.project.projectType]) {
				this.project.fieldSet = $.extend(true, {}, window.$.projectTypeFieldSets[this.project.projectType]);
			} else {
				this.project.fieldSet = $.extend(true, {}, window.$.SubjectManagement.DEFAULT_PROJECT_FIELD_SETS);
			}

			for(let i = 0; i < this.project.fieldSet.editableFields.length; i++) {
				let jobField = this.project.fieldSet.editableFields[i];
				let existingTemplateField = this.project.templateFields.find((templateField) => {
					return templateField.field_key == jobField.name || templateField.effective_label == jobField.name;
				});
				if(existingTemplateField) {
					continue;
				}

				let highestPosition = this.project.templateFields.reduce((highestPosition, templateField) => {
					return Math.max(highestPosition, templateField.arrangement_position ?? 0);
				}, 0);
				let response = await plicV1Axios.post('project-templates/' + this.project.template.id + '/subject-fields', {
					subject_field: {
						label: jobField.name,
						auto_suggest_enabled: !!jobField.group,
						arrangement_position: highestPosition + 1
					}
				});
				response.data.subject_field.effective_label = response.data.subject_field.label ?? response.data.subject_field.field_key;
				this.project.templateFields.push(response.data.subject_field);
			}

			this.checkedTemplateFields = true;
			this.checkDoneLoading();
		},
		checkDoneLoading() {
			if(this.project.plicSubjectAlbumId && this.project.templateFields && this.checkedTemplateFields) {
				this.loading = false;
			}
		}
	},
	mounted() {
		this.supportsInstagram = false;
	}
};
</script>

<style scoped>
.hiddenInput {
	display: none;
}

.select-folder, .instagram-button, .google-photos-button {
	margin-left: 0.5em;
}

.upload-third-party-button {
	height: 48px !important;
	margin-bottom: 0.5em;
}
.upload-third-party-button:deep(.v-btn__content) {
	width: 16em;
	text-wrap: wrap;
}
.logo-avatar {
	margin-right: 0.4em;
}

.info-alert {
	margin-top: 2em;
}

.link {
	text-decoration: underline;
}
.stop-button {
	margin-bottom: 0.5em;
}
</style>